export const parseOptmizerDefaultData = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'default-nome': item.curva,
      'default-min': item.min,
      'default-max': item.max,
      'default-default': item.default
    })
  }

  return res
}
